// Shared currency display helpers (#3593): the schedule editor, the project
// editor dropdowns, and the profile-derived defaults all draw from this one
// symbol map so a code renders the same everywhere.

export const CURRENCY_SYMBOLS: Record<string, string> = {
  USD: "$",
  EUR: "€",
  GBP: "£",
  AUD: "A$",
  CAD: "C$",
  JPY: "¥",
  CNY: "¥",
  CHF: "CHF ",
  HKD: "HK$",
  SGD: "S$",
  NZD: "NZ$",
  SEK: "kr ",
  NOK: "kr ",
  DKK: "kr ",
  INR: "₹",
  KRW: "₩",
  MXN: "MX$",
  BRL: "R$",
  ZAR: "R ",
  AED: "د.إ ",
};

export const CURRENCY_OPTIONS = Object.keys(CURRENCY_SYMBOLS);

/** "USD" → "$"; unmapped codes fall back to the code itself, no code → "$". */
export const currencySymbol = (code?: string): string =>
  code ? CURRENCY_SYMBOLS[code]?.trim() || code : CURRENCY_SYMBOLS.USD;

/** "USD" → "USD $" — dropdown/display label carrying the actual symbol. */
export const currencyLabel = (code: string | undefined): string => {
  if (!code) return "";
  const symbol = CURRENCY_SYMBOLS[code]?.trim();
  // Skip when there's no symbol or it just repeats the code (e.g. CHF).
  return symbol && symbol.toUpperCase() !== code.toUpperCase()
    ? `${code} ${symbol}`
    : code;
};
